import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import StatsRule from "../../../../common/stats-rule";
import { getPenaltyTeamIds } from "../../../utils/context-utils";

//In this case we only need to check the play for any penalties, that would prevent normal changing of downs

export default class ChangeDownStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const hasEopPenalty = play.historyContains(
            FootballState.PenaltyAccepted
        );
        const statsCount = super.applicable(
            gameContext,
            ruleContext,
            eventConfiguration,
            {
                play,
                fragment
            }
        );

        return (
            !ruleContext.PAT &&
            ruleContext.advanceDown &&
            !ruleContext.changeDownApplied &&
            (statsCount || hasEopPenalty)
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const stats = [];
        const penaltyAccepted = play.getPreceedingFragment(fragment, [
            FootballState.PenaltyAccepted,
            FootballState.PlayPenaltyPenaltyAccepted,
            FootballState.KickOffPenaltyAccepted
        ]);

        if (penaltyAccepted && !Array.isArray(penaltyAccepted)) {
            // A down decided by a penalty belongs to the team that had the
            // ball, not to the team that was flagged: a defensive penalty
            // gives the offense the first down. No individual player earns it,
            // so the record is team-level only.
            const { offenseTeamId } = getPenaltyTeamIds(play);

            this.recordDown(
                play,
                gameContext,
                ruleContext,
                { teamId: offenseTeamId, id: null },
                FootballState.Penalty,
                fragment,
                stats
            );
        } else if (play.historyContains(FootballState.Rush)) {
            const player = play.getFirstFragment(FootballState.Rush).rushedBy;

            this.recordDown(
                play,
                gameContext,
                ruleContext,
                player,
                FootballState.Rush,
                fragment,
                stats
            );
        } else if (play.historyContains(FootballState.Pass)) {
            const player = play.getFirstFragment(FootballState.Pass).passedBy;

            this.recordDown(
                play,
                gameContext,
                ruleContext,
                player,
                FootballState.Pass,
                fragment,
                stats
            );
        }

        return stats;
    }

    recordDown(
        play,
        gameContext,
        ruleContext,
        player,
        playType,
        fragment,
        stats
    ) {
        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: player.teamId,
                playerId: player.id,
                driveId: gameContext.currentDriveId,
                fragmentId: fragment.id,
                category: FootballStatsCategory.DOWN,
                values: { playType, down: gameContext.down, attempted: 1 }
            },
            stats
        );

        const { homeTeamHasPossession } = play.getContextSnapshot();
        if (homeTeamHasPossession === gameContext.homeTeamHasPossession) {
            if (
                (ruleContext.awardFirstDown && !ruleContext.playPoints) ||
                ruleContext.isTouchdown
            ) {
                this.addStats(
                    {
                        gameId: play.gameId,
                        playId: play.id,
                        period: gameContext.currentPeriod,
                        teamId: player.teamId,
                        playerId: player.id,
                        driveId: gameContext.currentDriveId,
                        fragmentId: fragment.id,
                        category: FootballStatsCategory.DOWN,
                        values: {
                            playType,
                            down: gameContext.down,
                            completed: 1
                        }
                    },
                    stats
                );
            }
        }
    }
}
